/* Glowco JP — comportamento das sections "glow-*"
   PT: carrossel do banner, setas dos carrosseis, play dos videos,
   abas de produtos e botao "comprar" que rola ate o bloco de compra. */
(function () {
  function initHero(root) {
    if (root.dataset.gcReady) return; root.dataset.gcReady = '1';
    var track = root.querySelector('.gc-hero__track');
    var dots = root.querySelectorAll('.gc-hero__dot');
    if (!track) return;
    var n = track.children.length, i = 0, timer = null;
    var delay = parseInt(root.dataset.autoplay || '0', 10) * 1000;
    function go(k) { i = (k + n) % n; track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
    function mark() {
      var k = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === k ? 'true' : 'false'); });
      i = k;
    }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); restart(); }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    function restart() {
      if (timer) clearInterval(timer);
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (delay > 0 && n > 1 && !reduce) timer = setInterval(function () { go(i + 1); }, delay);
    }
    root.addEventListener('pointerenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('pointerleave', restart);
    mark(); restart();
  }

  function initRails(scope) {
    scope.querySelectorAll('[data-gc-rail]').forEach(function (wrap) {
      if (wrap.dataset.gcReady) return; wrap.dataset.gcReady = '1';
      var rail = wrap.querySelector('.gc-rail');
      wrap.querySelectorAll('[data-gc-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = rail.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 16 : 300;
          rail.scrollBy({ left: step * parseInt(b.dataset.gcDir, 10), behavior: 'smooth' });
        });
      });
    });
  }

  function initVideos(scope) {
    scope.querySelectorAll('.gc-vcard').forEach(function (card) {
      if (card.dataset.gcReady) return; card.dataset.gcReady = '1';
      var v = card.querySelector('video'), b = card.querySelector('.gc-vcard__play');
      if (!v || !b) return;
      b.addEventListener('click', function () {
        document.querySelectorAll('.gc-vcard.is-playing video').forEach(function (o) { if (o !== v) { o.pause(); } });
        v.controls = true; v.muted = false; v.play(); card.classList.add('is-playing');
      });
      v.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      v.addEventListener('play', function () { card.classList.add('is-playing'); });
    });
  }

  function initTabs(scope) {
    scope.querySelectorAll('[data-gc-tabs]').forEach(function (box) {
      if (box.dataset.gcReady) return; box.dataset.gcReady = '1';
      var tabs = box.querySelectorAll('[role="tab"]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) {
            var on = o === t; o.setAttribute('aria-selected', on ? 'true' : 'false');
            var p = box.querySelector('#' + o.getAttribute('aria-controls')); if (p) p.hidden = !on;
          });
        });
      });
    });
  }

  function initBuyLinks(scope) {
    scope.querySelectorAll('a[href="#buy"]').forEach(function (a) {
      if (a.dataset.gcReady) return; a.dataset.gcReady = '1';
      a.addEventListener('click', function (e) {
        var t = document.querySelector('product-info, .product__info-wrapper, form[action*="/cart/add"]');
        if (!t) return;
        e.preventDefault();
        var y = t.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('.gc-hero').forEach(initHero);
    initRails(scope); initVideos(scope); initTabs(scope); initBuyLinks(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
